import React, { Component } from 'react'
import '../stylesheets/components/project.scss';

class Project extends Component{

	render(){
		return (
			<section className="o-project" id="sobre">
				<div className="o-container" >
					<h2 className="c-title c-title--size-big c-title--family-bold c-title--color-white c-title--align-left c-title--border c-title--border-bottom">
						O Projeto
					</h2>

					<div className="o-row" >

						<div className="o-col o-col--width" >
							<p className="c-title c-title--width-medium c-title--color-white c-title--lineheight-3" >
								Mais da metade da população brasileira não possui acesso 
								à Internet. E para ajudar esses e os mais de 60 milhões de 
								brasileiros negativados de um jeito simples e digital, o 
								Serasa Itinerante, ou Caminhão da Serasa, vai rodar mais 
								de 18 mil quilômetros, de Norte a Sul do país, para levar 
								acesso a informações e serviços financeiros, como 
								consulta grátis de CPF, Serasa Score e renegociação de 
								dívidas em tempo real.
							</p>
						</div>

						<div className="o-col" >
							<p className="c-title c-title--width-medium c-title--color-white c-title--lineheight-3 c-title--align-center o-uppercase" >
								Apoio:
							</p>

							<div className="o-row o-row--align-center" >
								<div className="o-col o-col--width o-col--border-right o-col--align-center" >
									<img src={ process.env.PUBLIC_URL + "/images/partners/visa.png" } className="" alt="" />
								</div>
								<div className="o-col o-col--width o-col--align-center" >
									<img src={ process.env.PUBLIC_URL + "/images/partners/pagseguro.png" } className="" alt="" />
								</div>
							</div>

							<br />

							<p className="c-title c-title--width-medium c-title--color-white c-title--lineheight-3" >
								Em nosso segundo ano de projeto, contamos com as parcerias Visa e Pag Seguro. Além disso, junto com a AEF-Brasil (Associação de Educação Financeira do Brasil ), temos o objetivo de ensinar milhares de alunos, de todo o país, a como lidar com seu próprio dinheiro.
							</p>
						</div>

					</div>

				</div>

			</section>
		)
	}

}

export default Project


// WEBPACK FOOTER //
// ./src/components/Project.js